'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function (options) {
  var appConfig = options.appConfig,
      bodyClass = options.bodyClass,
      client = options.client,
      configureStore = options.configureStore,
      configureRoutes = options.configureRoutes,
      stylesheet = options.stylesheet,
      webpackIsomorphicTools = options.webpackIsomorphicTools;


  return function rendering(req, res, next) {
    if (__DEVELOPMENT__ && webpackIsomorphicTools) {
      webpackIsomorphicTools.refresh();
    }

    var memoryHistory = (0, _createMemoryHistory2.default)(req.originalUrl);
    var store = configureStore(memoryHistory, client);
    var history = (0, _reactRouterRedux.syncHistoryWithStore)(memoryHistory, store);
    var unplug = _reactCookie2.default.plugToRequest(req, res);

    function renderPage(props) {
      return _server2.default.renderToStaticMarkup(_react2.default.createElement(_HTMLComponent2.default, (0, _extends3.default)({}, props, {
        appConfig: appConfig,
        assets: webpackIsomorphicTools.assets(),
        bodyClass: bodyClass,
        store: store,
        i18n: req.i18n,
        stylesheet: stylesheet
      })));
    }

    function renderAndRespond(status) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      try {
        var html = renderPage(props);
        res.status(status).send('<!doctype html>\n' + html);
        unplug();
      } catch (e) {
        console.error(_chalk2.default.red('Chemist could not render the page.'));
        next(e);
      }
    }

    var routeConfig = {
      history: history,
      routes: configureRoutes(store),
      location: req.originalUrl
    };

    (0, _reactRouter.match)(routeConfig, function (error, redirectLocation, renderProps) {
      if (redirectLocation) {
        res.redirect(redirectLocation.pathname + redirectLocation.search);
        unplug();
      } else if (error) {
        renderAndRespond(500);
      } else if (renderProps) {
        (0, _reduxConnect.loadOnServer)((0, _extends3.default)({}, renderProps, { store: store, helpers: { client: client } })).then(function () {
          return (0, _reactI18next.loadNamespaces)((0, _extends3.default)({}, renderProps, { i18n: req.i18n }));
        }).then(function () {
          var notFound = renderProps.routes.some(function (route) {
            return route.status === 404;
          });
          var statusCode = notFound ? 404 : 200;
          var component = _react2.default.createElement(_ServerApp2.default, {
            appConfig: appConfig,
            renderProps: renderProps,
            req: req,
            store: store
          });

          global.navigator = { userAgent: req.headers['user-agent'] };
          renderAndRespond(statusCode, { component: component });
        }).catch(function (err) {
          throw err;
        });
      }
    });
  };
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _chalk = require('chalk');

var _chalk2 = _interopRequireDefault(_chalk);

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _createMemoryHistory = require('react-router/lib/createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _reactI18next = require('react-i18next');

var _HTMLComponent = require('./HTMLComponent');

var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);

var _ServerApp = require('./ServerApp');

var _ServerApp2 = _interopRequireDefault(_ServerApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/middleware/rendering/index.js
// module id = 652
// module chunks = 0